import clsx from 'clsx'
import { Col, Icon, Row } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import Money from '../../Money'
import styles from 'modules/Services/Account/subcomponents/TransactionsList/transactions-list.module.scss'
import { useTranslation } from 'react-i18next'

const TransactionRow = (props) => {
  const { t } = useTranslation(['services'])

  const {
    id = null,
    status = null,
    amount = '',
    currency = '',
    direction,
  } = props

  const heading = useMemo(
    () => (direction ? t(`transfers_list.direction.${direction}`) : ''),
    [direction],
  )

  const action = useMemo(
    () =>
      `${id ? `ID: ${id}.` : ''} ${
        status ? t(`transfers_list.status.${status}`) : ''
      }`,
    [id, status],
  )

  const breakpoints = useBreakpoint()

  const isPositive = direction === 'in'
  const suffix = isPositive ? 'up' : 'down'

  const color = isPositive ? 'secondary-11' : 'secondary-46'

  return (
    <Row className={styles['transfers__row']}>
      <Col sm="auto" xs="auto" className={styles['transfers__col']}>
        <div
          className={clsx(
            styles['transfers__badge'],
            styles['transfers__badge_' + suffix],
          )}
        >
          <Icon
            width={!breakpoints.md ? 16 : 11}
            name="arrow-rounded"
            color={color}
          />
        </div>
      </Col>
      <Col className={styles['transfers__col']} fluid>
        <div className={styles['transfers__heading']} title={heading}>
          {heading}
        </div>
        <div className={styles['transfers__action']}>{action}</div>
      </Col>
      <Col xs="4" className={styles['transfers__col']}>
        <div
          className={clsx(
            styles['transfers__cost'],
            styles['transfers__cost_' + suffix],
          )}
        >
          <Money number={amount} currency={currency} />
        </div>
      </Col>
    </Row>
  )
}

export default TransactionRow

TransactionRow.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currency: PropTypes.string,
  action: PropTypes.string,
  heading: PropTypes.string,
  direction: PropTypes.string,
  status: PropTypes.string,
  id: PropTypes.number,
  created_at: PropTypes.string,
}
